import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, Button } from '@/components/ui';
import { ChevronLeft, ChevronRight, Calendar as CalendarIcon, Info } from 'lucide-react';

export const AttendanceCalendar: React.FC = () => {
  const days = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];

  // Dummy data for visualization
  const calendarDays = Array.from({ length: 31 }, (_, i) => ({
    day: i + 1,
    status: i === 12 || i === 24 ? 'late' : i > 25 ? 'future' : 'present',
    hours: i > 25 ? 0 : 8.5
  }));

  return (
    <Card className="border-none shadow-sm bg-white rounded-[32px] overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between p-6 border-b border-slate-50">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600">
            <CalendarIcon className="w-5 h-5" />
          </div>
          <div>
            <CardTitle className="text-sm font-black  tracking-widest text-slate-900">Lịch chấm công cá nhân</CardTitle>
            <p className="text-[10px] text-slate-400 font-bold  tracking-wider">Tháng 05 / 2026</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" className="w-8 h-8 p-0 rounded-lg hover:bg-slate-100">
            <ChevronLeft className="w-4 h-4" />
          </Button>
          <Button variant="ghost" size="sm" className="w-8 h-8 p-0 rounded-lg hover:bg-slate-100">
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="p-6">
        <div className="grid grid-cols-7 gap-2 mb-4">
          {days.map(day => (
            <div key={day} className="text-center text-[10px] font-black text-slate-400  tracking-widest pb-2">
              {day}
            </div>
          ))}
          {calendarDays.map((d, i) => (
            <div
              key={i}
              className={`
                aspect-square rounded-2xl flex flex-col items-center justify-center gap-1 transition-all cursor-pointer group relative
                ${d.status === 'present' ? 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100' : ''}
                ${d.status === 'late' ? 'bg-amber-50 text-amber-700 hover:bg-amber-100' : ''}
                ${d.status === 'future' ? 'bg-slate-50/50 text-slate-300' : ''}
              `}
            >
              <span className="text-xs font-black">{d.day}</span>
              {d.hours > 0 && (
                <span className="text-[8px] font-bold opacity-60">{d.hours}h</span>
              )}
              {d.status === 'late' && (
                <div className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-amber-500 shadow-[0_0_5px_#f59e0b]" />
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 rounded-2xl bg-slate-50 border border-slate-100 flex items-start gap-3">
          <Info className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" />
          <p className="text-[10px] text-slate-500 leading-relaxed font-medium">
            Màu sắc ô lịch thể hiện trạng thái chấm công:
            <span className="text-emerald-600 font-bold ml-1">Xanh (Đủ công)</span>,
            <span className="text-amber-600 font-bold ml-1">Vàng (Muộn/Về sớm)</span>,
            <span className="text-red-500 font-bold ml-1">Đỏ (Vắng)</span>.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
